module.exports = __webpack_public_path__ + "img/astronaut_image.5e9e441a.jpg";